export const fontFamily = {
  default: '"メイリオ", "ヒラギノ角ゴ Pro W3", "游ゴシック体", sans-serif',
  Noto: '"Noto Sans JP", sans-serif',
  Roboto: '"Roboto", "Noto Sans JP", sans-serif',
} as const
